<template>
  <w-settings-content-template side-title="로그 대상 목록">
    <div slot="sideContent">
      <w-ml-log-tree @selectNode="selectLogid"></w-ml-log-tree>
    </div>
    <div slot="content">
      <el-row :gutter="20">
          <el-row type="flex" justify="space-between" class="title-bar">
            <div class="vertical-center-box">
              <div class="title-h3">머신러닝 패턴 목록</div>
              <el-button type="primary" size="mini" class="mr-l15 mr-r4" @click="SearchPattern" :disabled="checkSelectLog()">패턴 탐색</el-button>
              <el-button type="primary" size="mini" @click="deleteMlPattern" :disabled="!checkSelectMlPattern">패턴 삭제</el-button>
              <el-popover class="mr-l10" placement="bottom" width="500" trigger="hover" :offset="40">
                <span class="text"> - 패턴탐색 시 최근에 발생한 미확인 패턴 로그를 조회해 분석합니다. <br/> - 패턴 탐색 시 시간 범위는 현재부터 <em>{{originPatternDateCycle}}시간 이전</em>까지 합니다.</span>
                <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
              </el-popover>
            </div>
            <div class="vertical-center-box" align="right">
              <span class="mr-r4">자동 탐색 주기</span>
              <el-input-number class="mr-r4" v-model="patternDateCycle" controls-position="right" :min="1" :max="999"></el-input-number>
              <span class="mr-r10">시간</span>
              <el-button type="primary" size="mini" class="mr-r4" @click="updateMlSetting" :disabled="checkUpdateFlag && dataSearchCycleFlag">저장</el-button>
              <el-button size="mini" class="mr-r4" @click="resetPatternData"  :disabled="checkUpdateFlag && dataSearchCycleFlag">취소</el-button>
              <w-header-search-button size="mini" @click="showSearchMlPattern"/>
            </div>
          </el-row>
          <!--머신러닝 테이블-->
          <el-table-wrapper ref="mlTable" v-loading="loading" :column-default="columnDefault" :data="machinePatternData" row-class-name="c-dblclick" :columns="machinePatternColumns" @condition-change="setTableParameter"
          highlight-current-row :show-custom-header="true" :total="total" :show-search-tool="searchMlFlag" header-align="center" @cell-dblclick="showLogPatternPopup" @selection-change="changeSelection" remote>
            <template slot-scope="scope" slot="use-flag-slot">
              <el-switch v-model="scope.row.useFlag" active-value="Y" inactive-value="N" @change="checkPatternModify"/>
            </template>
          </el-table-wrapper>
      </el-row>
      <w-log-pattern-setting-popup ref="patternSetting" @loadData="loadPatternData()" :mlFlag="true" :selectedLogid="selectedLogid" :selectedPattern="selectPattern"></w-log-pattern-setting-popup>
    </div>
  </w-settings-content-template>
</template>

<script>
import { isEmpty, cloneDeep, differenceWith, isEqual, isNil } from 'lodash';
import moment from 'moment';

import { columnDefault } from '@/constants/table';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import LmsMlAPI from '@/api/settings/log/lms-machine-learning-setting';
import PatternSearchAPI from '@/api/settings/log/lms-pattern-search-setting';
import msgUtil from '@/utils/message';
import WSearchField from '@/components/form/SearchField';

import WMlLogTree from './MlLogTree';
import WLogPatternSettingPopup from '../popup/LogPatternSettingPopup';

export default {
  name: 'WMachineLearningPattern',
  components: {
    WSettingsContentTemplate,
    WLogPatternSettingPopup,
    WSearchField,
    WMlLogTree,
  },
  data() {
    return {
      patternDateCycle: null,
      originPatternDateCycle: null,
      loadingMlSearch: false,
      loading: false,
      searchWidth: '100%',
      start: 0,
      limit: 50,
      total: 0,
      searchParams: [],
      originPatternData: [],
      updateList: [],
      deleteList: [],
      searchFlag: false,
      searchMlFlag: false,
      checkSelectMlPattern: false,
      checkUpdateFlag: true,
      logidTableData: [],
      selectPattern: null,
      selectedLogid: null,
      defaultProps: {
        nodeKey: 'nodeKey',
        children: 'children',
        label: 'label',
        isLeaf: 'leaf',
        showOverflowTooltip: true,
      },
      logidTableColumn: [
        {
          label: '로그 대상',
          prop: 'logTargetId',
          searchable: true,
        },
      ],
      columnDefault,
      showSearchTool: false,
      machinePatternData: [],
      machinePatternColumns: [
        {
          type: 'selection',
          width: '50px',
          prop: 'check_flag',
        },
        {
          label: '활성화',
          width: 70,
          prop: 'useFlag',
          scopedSlot: 'use-flag-slot',
          headerAlign: 'center',
          align: 'center',
        },
        {
          label: '머신러닝 패턴명',
          prop: 'mlPatternName',
          remoteProp: 'ml_pattern_name',
          searchable: true,
          width: 300,
        },
        {
          label: '패턴',
          searchable: true,
          prop: 'mlPattern',
          remoteProp: 'ml_pattern',
        },
      ],
    };
  },
  mounted() {
    this.loadSearchTime();
  },
  computed: {
    dataSearchCycleFlag() {
      return (this.originPatternDateCycle === parseInt(this.patternDateCycle, Number));
    },
  },
  methods: {
    /**
     * 자동 탐색 주기 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadSearchTime() {
      PatternSearchAPI.getSearchTime().then((response) => {
        if (response.data.success) {
          this.patternDateCycle = response.data.data;
          this.originPatternDateCycle = cloneDeep(response.data.data);
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자동 탐색 주기', false));
        throw new Error(e);
      });
    },
    /**
     * 자동 탐색 주기 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    updatePatternDateCycle() {
      const params = {
        basicinfoId: 'LOG_ML',
        basicinfoSubid: 'SCHEDULE_HOUR',
        basicinfoSubvalueInteger: this.patternDateCycle,
      };
      PatternSearchAPI.updateSearchTime(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '탐색 주기', true));
          this.loadSearchTime();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '탐색 주기', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '탐색 주기', false));
        throw new Error(e);
      });
    },
    /**
     * 패턴 탐색 버튼 클릭 시 작동 함수
     * @author leesy918
     */
    SearchPattern() {
      this.loadingMlSearch = true;
      const param = this.setSearchUncheckpatternParam();
      PatternSearchAPI.SearchUncheckPattern(param).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getCustomResultMsgData('패턴 탐색이 완료되었습니다.', true));
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.RUN, '패턴 탐색', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.RUN, '패턴 탐색', false));
        throw new Error(e);
      }).finally(() => {
        this.loadingMlSearch = false;
      });
    },
    /**
     * 패턴 탐색 시 파라미터 작성 함수
     * @author leesy918
     */
    setSearchUncheckpatternParam() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.RUN, '패턴 탐색', true));
      const endDateTime = moment().toDate();
      let startDateTime = moment().subtract(1, 'hours').toDate();
      if (!isNil(this.patternDateCycle)) {
        startDateTime = moment().subtract(this.patternDateCycle, 'hours').toDate();
      }
      const queryList = [
        {
          field: 'mlPatternId',
          operator: 'AND',
          regex: 'N',
          value: 0,
        },
        {
          field: 'objId',
          operator: 'AND',
          regex: 'N',
          value: this.selectedLogid.objId,
        },
      ];
      if (this.selectedLogid.logType === 'APP') {
        queryList.push({
          field: 'applogId',
          operator: 'AND',
          regex: 'N',
          value: this.selectedLogid.logTargetId,
        });
      }
      const param = {
        type: 'dataindex',
        dataindexId: this.selectedLogid.dataindexId,
        startDateTime,
        endDateTime,
        logId: this.selectedLogid.logId,
        limit: 1000,
        logTargetId: this.selectedLogid.logTargetId,
        objId: this.selectedLogid.objId,
        queryList,
        start: 0,
      };
      return param;
    },
    /**
     * 로그 선택 여부 확인 함수
     * @author lees918
     * @return {[type]} [description]
     */
    checkSelectLog() {
      if (this.loadingMlSearch) {
        return true;
      }
      return false;
    },
    selectLogid(value) {
      if (value.leaf) {
        this.selectedLogid = value;
        this.$refs.mlTable.setCurrentPage(1);
        this.start = 0;
        this.searchParams = [];
      }
    },
    setTableParameter(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.searchParams = value.searchParams;
      this.loadPatternData();
    },
    showSearchMlPattern() {
      this.searchMlFlag = !this.searchMlFlag;
    },
    showSearchHeader() {
      this.searchFlag = !this.searchFlag;
    },
    /**
     * 머신러닝 패턴 삭제
     * @author leesy918
     * @return {[type]} [description]
     */
    deleteMlPattern() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const params = this.deleteList;
        LmsMlAPI.deleteMachineLearning(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '패턴', true));
            this.loadPatternData();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '패턴', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '패턴', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    /**
     * 머신 러닝 메뉴 설정 업데이트
     * @author leesy918
     * @return {[type]} [description]
     */
    updateMlSetting() {
      if (!this.dataSearchCycleFlag) {
        this.updatePatternDateCycle();
      }
      if (!this.checkUpdateFlag) {
        this.updateMlPattern();
      }
    },
    /**
     * 머신러닝 활성화 여부 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    updateMlPattern() {
      const params = this.updateList;
      LmsMlAPI.saveActivePatternFlag(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '패턴', true));
          this.loadPatternData();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '패턴', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '패턴', false));
        throw new Error(e);
      });
    },
    /**
     * 머신러닝 패턴 목록 삭제할 패턴 선택
     * @author leey918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    changeSelection(data) {
      this.deleteList = data;
      this.checkSelectMlPattern = !isEmpty(data);
    },
    /**
     * 활성화 변경 여부 체크
     * @author leesy918
     * @return {[type]} [description]
     */
    checkPatternModify() {
      const updateList = differenceWith(this.machinePatternData, this.originPatternData, isEqual);
      this.updateList = updateList;
      this.checkUpdateFlag = isEmpty(updateList);
    },
    /**
     * 변경된 머신러닝 리스트 초기화
     * @author leesy918
     */
    resetPatternData() {
      this.machinePatternData = cloneDeep(this.originPatternData);
      this.patternDateCycle = this.originPatternDateCycle;
    },
    /**
     * 머신러닝 패턴 수정 팝업 출력
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    showLogPatternPopup(data) {
      this.selectPattern = data;
      this.$refs.patternSetting.open();
    },
    loadPatternData() {
      const param = this.selectedLogid;
      param.start = this.start;
      param.limit = this.limit;
      param.searchParams = this.searchParams;
      this.loading = true;
      LmsMlAPI.getMachineLearningList(param).then((response) => {
        if (response.data.success) {
          this.originPatternData = cloneDeep(response.data.data);
          this.machinePatternData = response.data.data;
          this.total = response.data.total;
          this.checkUpdateFlag = true;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '머신러닝 패턴', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '머신러닝 패턴', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Pattern/components/MachineLearningPattern.vue